import { Component, OnInit, Input } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare function testrun(): void;
import { Router} from '@angular/router';
@Component({
    selector:'InstallationRequest',
    templateUrl: './AppViews/Warranty/installation.html'
})


export class InstallationComponent implements OnInit {
    constants: Constants;
    userDetail: any;
    filterClient: any="";
    filterTitle: any="";
    Search: any="";
    IRList: any=[];
    public showLoader = false;
    public isProjectScreen: boolean = false; 
    filter: any = { 'ProjectId': "", 'CustomerId': ""};
    projectListMain : any = [];
    projectList: any = [];
    customerList: any = [];
    public projectId: any="";
    customerId: any="";
    AssetCount: any="";
    @Input() installationRefresh:string;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, 
        private _datepipe: DatePipe,private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
      
    }

    ngOnInit() {
        this.GetIRListFull();
        this.GetProjectList();
    }

    ngOnChanges(){
        this.GetIRList();
        this.GetProjectList(); 
    }

    GetProjectList() {
        this.showLoader = true;
        this._httpService.ajaxPost("InstallationRequest/GetProjectIR",
            { "ProjectId": 0, "ProjectType": this.constants.projectType.HWInstallation, "Status": 1, "CustomerId": 0,"IsListFilter":true,"LoginUserId":this.userDetail.SiteUserId }).subscribe(
                data => {
                    this.customerList = data["CustomerList"];
                    this.projectListMain = data["ProjectList"];
                    if (this.filter.CustomerId > 0 && this.projectListMain != null && this.projectListMain.length > 0) {
                        this.projectList = this.projectListMain.filter(x => x.Customer_Id == this.filter.CustomerId);
                    }
                    else
                    {
                        this.projectList = this.projectListMain;
                    }

                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    onCustomerChange(customerId) {
        if (customerId > 0 && this.projectListMain != null && this.projectListMain.length > 0) {
            this.projectList = this.projectListMain.filter(x => x.Customer_Id == customerId);
        }
    }


    GetIRListFull() {
        this.showLoader = true;
        localStorage.removeItem('IsFromInstallation');
        localStorage.setItem('IsFromInstallation', "1");
        this.IRList=[];
        this._httpService.ajaxPost("InstallationRequest/GetInstallationRequest",
            { "IRId": 0, "ProjectId": "", "CustomerId": this.filter.CustomerId, "Status": 0 ,"LoginUserId":this.userDetail.SiteUserId}).subscribe(
                data => {
                    this.IRList = data["IRList"];               
                   
                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    GetIRList() {
        this.showLoader = true;
        localStorage.removeItem('IsFromInstallation');
        localStorage.setItem('IsFromInstallation', "0");
        this.filter.ProjectId = this.projectId;

        this.IRList=[];
        this._httpService.ajaxPost("InstallationRequest/GetInstallationRequest",
            { "IRId": 0, "ProjectId": this.filter.ProjectId, "CustomerId": this.filter.CustomerId, "Status": 0 ,"LoginUserId":this.userDetail.SiteUserId}).subscribe(
                data => {
                    this.IRList = data["IRList"];               
                   
                },
                err => {
                    console.log("GetProjectList Failed");
                    this.showLoader = false;
                },
                () => {
                    this.showLoader = false;
                }
            );
    }

    OpenAddScreen()
    {
        localStorage.setItem("ProjectId", JSON.stringify(this.projectId));
        localStorage.setItem("CustomerId", JSON.stringify(this.customerId));
        if(this.isProjectScreen){
            localStorage.setItem("AssetCount", JSON.stringify(this.AssetCount));
        }
        else{
            localStorage.removeItem("AssetCount");
        }
        this._route.navigateByUrl("/installationAdd");
    }

    clearFilter()
    {
        this.filter.ProjectId = "";
        this.filter.CustomerId = "";
        this.Search = "";
        this.projectList = this.projectListMain;
        this.GetIRListFull();
    }

    public DeleteIR(IRId,AssetCount){
        if(AssetCount<=0){
            this.showLoader = true;
            this._httpService.ajaxPost('InstallationRequest/DeleteIR', { "IRId": IRId}).subscribe(
                data => {
                    var msg = data["Status"].Message.split('|');
                    if (msg.length >= 1) {
    
                        msg[0] = msg[0].toLowerCase();
                        if (msg[0] == "success") {
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                            this.GetIRList();
                        }
                        else if (msg[0] == "warning") {
                            this._sharedService.ShowMessage(msg[0] + "|" + msg[1]);
                        }
                        else {
                            this._sharedService.ShowMessage(this.constants.globalError);
                        }
                    }
                    else {
                    }
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
    
                () => {
                        this.showLoader = false;
                }
            );
        }
    }



}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Warranty/installation.component.ts
 **/